import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const popularFaqs = [
  {
    q: "When can I expect to receive my order?",
    a: "Please allow 6-14 days in total for your handmade garment to reach you."
  },
  {
    q: "Can I return my order?",
    a: (
      <>
        Yes, You can easily return your order as long as it wasn’t customised. Please check out our {" "}
        <Link to="/return-policy" className="underline">Return Policy</Link>, {" "}
        <Link to="/exchange-policy" className="underline">Exchange Policy</Link>, and {" "}
        <Link to="/return-policy" className="underline">Cancellations</Link> for all details.
      </>
    )
  },
  {
    q: "Are all Nufab pieces handmade?",
    a: "Yes. Every single piece is stitched by hand, to-order, ethically with hand-dyed fabric."
  },
  {
    q: "Does Nufab offer customisation?",
    a: (
      <>
        Yes, we provide simple customisations free of cost for some garments! Simply use the customise button before adding a piece to cart. For legal details, please read our {" "}
        <Link to="/terms-of-service" className="underline">Terms of Service</Link> and {" "}
        <Link to="/privacy-policy" className="underline">Privacy Policy</Link>.
      </>
    )
  },
  {
    q: "How do I know my size?",
    a: (
      <>
        Please refer to our {" "}
        <Link to="/store" className="underline">size chart</Link>.
      </>
    )
  },
  {
    q: "Will my piece look exactly like the photos?",
    a: "Our images are the closest and most accurate representation of our clothes, but no two hand-made pieces are ever exactly alike. However, you can trust our photographs to never be misleading."
  }
];

const FaqSnippet = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    // RESPONSIVE: Adjusted padding (px-4 py-12 on mobile, px-8 py-20 on desktop)
    <div className="w-full max-w-full mx-auto px-2 py-12 md:px-4 md:py-20 font-bdogrotesk bg-white">
      
      {/* RESPONSIVE: Flex col on mobile, Row on Large screens (lg:flex-row) */}
      <div className="max-w-full mx-auto flex flex-col lg:flex-row gap-8 md:gap-12 lg:gap-8">
        
        {/* Left Section - Header */}
        {/* RESPONSIVE: Full width on mobile, 1/2 on desktop. Aligned start on mobile, center on desktop */}
        <div className="w-full lg:w-1/2 flex items-start lg:justify-center ">
          {/* RESPONSIVE: Text scales from 4xl to 7xl */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-medium text-black">FAQs</h2>
        </div>

        {/* Right Section - FAQ Items */}
        {/* RESPONSIVE: Full width on mobile, 1/2 on desktop */}
        <div className="w-full lg:w-1/2 space-y-0">
          {popularFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="border-b border-black p"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex justify-between items-start md:items-center text-left group py-2"
                >
                  {/* RESPONSIVE: Adjusted font size slightly for very small screens if needed */}
                  <span className="text-sm md:text-base font-medium text-black pr-4 md:pr-8">
                    {index + 1}. {faq.q}
                  </span>
                  <span className="text-xl md:text-2xl font-bdogrotesk-medium text-black flex-shrink-0">
                    {isOpen ? "×" : "+"}
                  </span>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? "max-h-96 mt-2 md:mt-4 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  {/* RESPONSIVE: Adjusted right padding */}
                  <p className="text-sm md:text-base leading-relaxed text-black pr-2 md:pr-12 pb-2">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
          
          {/* All FAQs Link */}
          <div className="pt-6 md:pt-4">
            <Link
              to="/faqs"
              className="inline-flex items-center gap-2 text-sm md:text-base font-medium text-black underline-offset-4 decoration-1"
            >
              All FAQs
              <span className="text-lg">↗</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqSnippet;